import { Text, View } from '@react-pdf/renderer';

import { COMMENTARY_TEXT } from '../../commentary/consts.ts';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { CompTypeBadge } from '../components/CompTypeBadge.tsx';
import { Table } from '../components/Table.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles } from '../styles.ts';
import { PriorSalesPageProps } from '../types.ts';

export const PriorSalesPage = ({
  subjectAddress,
  commentaryV2,
  compSequence,
  priorSales,
  compTypes,
}: PriorSalesPageProps) => {
  const { title } = COMMENTARY_TEXT['prior-sales'];

  return (
    <Tkv2PDFPage title={title} address={subjectAddress}>
      <CommentarySection
        title="Prior Sales Commentary"
        commentary={commentaryV2.priorSales?.commentary}
      />

      <View style={{ height: 12 }} />

      {['subject', ...compSequence].map((id, i) => {
        const propertyPriorSales = priorSales[id];
        const propertyTitle = id === 'subject' ? 'Subject' : `Comparable ${i}`;

        const compType = compTypes[id];
        const propertyTitleElement = (
          <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 4 }}>
            <Text style={fontStyles.bodyBold}>{propertyTitle}</Text>
            {compType && <CompTypeBadge compType={compType} fullText compact />}
          </View>
        );

        if (!propertyPriorSales || propertyPriorSales.length === 0) {
          return (
            <View key={id}>
              {propertyTitleElement}
              <Text style={fontStyles.bodyLight}>No Prior Sales</Text>
            </View>
          );
        }

        return (
          <View key={id}>
            {propertyTitleElement}
            <Table>
              <Table.Column>
                <Table.TextCell>Prior Sale Date</Table.TextCell>
                <Table.TextCell>Prior Sale Price</Table.TextCell>
                <Table.TextCell>Prior Listing Date</Table.TextCell>
                <Table.TextCell>Prior Listing Price</Table.TextCell>
                <Table.TextCell>Data Source(s)</Table.TextCell>
              </Table.Column>
              {propertyPriorSales.map(
                ({ CloseDate, ClosePrice, ListingContractDate, ListPrice }) => (
                  <Table.Column key={CloseDate}>
                    <Table.TextCell>{CloseDate}</Table.TextCell>
                    <Table.TextCell>{ClosePrice}</Table.TextCell>
                    <Table.TextCell>{ListingContractDate}</Table.TextCell>
                    <Table.TextCell>{ListPrice}</Table.TextCell>
                    <Table.TextCell>MLS</Table.TextCell>
                  </Table.Column>
                ),
              )}
            </Table>
          </View>
        );
      })}
    </Tkv2PDFPage>
  );
};
